import React from 'react'
import styled from 'styled-components'
import { Button, Colors, Modal, Display2 } from 'advenio-components'
import { Form } from 'formsy-react'
import PropTypes from 'prop-types'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`
const Text = styled(Display2)`
  color: ${Colors.gray700};
  margin-bottom: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
`

const ConfirmDeleteChargeModal = ({ chargeId, handleSubmit, isOpen, loading, onClose, typeToDelete }) => (
  <Modal
    isOpened={isOpen}
    onClose={onClose}
    headerTitle={`¿Borrar ${typeToDelete}?`}
  >
    <Container>
      <Form onSubmit={() => handleSubmit(chargeId)}>
        <Text>¿Seguro que deseas borrar este {typeToDelete}?</Text>
        <ButtonContainer>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            primary
            loading={loading}
            type="submit"
          >
            Borrar {typeToDelete}
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  </Modal>
)

ConfirmDeleteChargeModal.propTypes = {
  /** The student charge to be deleted */
  chargeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  /** Callback function to be fired when submitting the form */
  handleSubmit: PropTypes.func.isRequired,
  /** Indicates if the modal should be open or not */
  isOpen: PropTypes.bool,
  /** Indicates if the charge is in the process of being deleted */
  loading: PropTypes.bool.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
  /** Type of element to delete */
  typeToDelete: PropTypes.string.isRequired,
}

ConfirmDeleteChargeModal.defaultProps = {
  chargeId: null,
  isOpen: false,
}

export default ConfirmDeleteChargeModal



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Balance/ConfirmDeleteChargeModal.jsx